import { useTranslation } from "react-i18next";
import { FlexWrapper } from "../../../../style/FlexWrapper";
import { ButtonCancel, ButtonConfirm } from "../../../Layout/Buttons";
import {
  useAddPolicySubjectContext,
  useAddPolicySubjectDispatch,
} from "./AddPolicySubjectContext";
import { Address } from "../../../../redux/apiSpecifications/apiSubjects";
import SubjectAddessesForm from "../Forms/SubjectAddessesForm";

interface IAddressesStepProps {
  onNextStep: () => void;
  onPreviousStep: () => void;
}

const AddressesStep = ({ onNextStep, onPreviousStep }: IAddressesStepProps) => {
  const { t } = useTranslation();

  const dispatch = useAddPolicySubjectDispatch();

  const { addPolicySubjectData } = useAddPolicySubjectContext();

  const handleOnEditAddress = (address: Address) => {
    let subjectAddresses: Address[] = [];

    if (addPolicySubjectData?.addresses === undefined) {
      subjectAddresses.push(address);
    } else {
      const result = addPolicySubjectData?.addresses?.find(
        (_) => _.type === address.type
      );

      if (result === undefined) {
        subjectAddresses = [...addPolicySubjectData?.addresses!, address];
      }
    }

    dispatch!({
      type: "CHANGE_POLICY_SUBJECT_DATA",
      payload: {
        value: subjectAddresses,
        field: "addresses",
      },
    });
  };

  const handleOnDeleteAddress = (address: Address) => {
    if (addPolicySubjectData?.addresses !== undefined) {
      dispatch!({
        type: "CHANGE_POLICY_SUBJECT_DATA",
        payload: {
          value: addPolicySubjectData?.addresses.filter(_ => _.type !== address.type),
          field: "addresses",
        },
      });
    }
  }

  return (
    <FlexWrapper flexDirection="column" gap="2em">
      <SubjectAddessesForm
        addresses={addPolicySubjectData?.addresses}
        onEditAddress={handleOnEditAddress}
        onDeleteAddress={handleOnDeleteAddress}
      />

      <FlexWrapper gap="1em" justifyContent="flex-end">
        <ButtonCancel onClick={onPreviousStep}>
          {t("BUTTONS.previous")!}
        </ButtonCancel>

        <ButtonConfirm onClick={onNextStep}>
          {t("BUTTONS.next")!}
        </ButtonConfirm>
      </FlexWrapper>
    </FlexWrapper>
  );
};

export default AddressesStep;
